import { render, staticRenderFns } from "./ExpenseListNew.vue?vue&type=template&id=132292a4&"
import script from "./ExpenseListNew.vue?vue&type=script&lang=js&"
export * from "./ExpenseListNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports